import React from 'react';
import { useStandingsFirstLeague, useAllStandingsSecondLeague } from '../../hooks/standingsHooks/useStandingsData';
import { useLeagueSelection } from '../../hooks/useLeagueSelection';
import config from '../../config';
import BigTable from "./components/Table";
import TebleLegende from "./components/Legende";
import './TablePage.css';

const TablePage = () => {
    const { leagueLevel } = useLeagueSelection();
    const { data: tableFirstLeague, isLoading: isLoadingTableFirst, error: errorFirst } = useStandingsFirstLeague();
    const { data: tableSecondLeague, isLoading: isLoadingTablesSecond, error: errorSecond } = useAllStandingsSecondLeague();
    if ((leagueLevel === "1" && errorFirst) || (leagueLevel === "2" && errorSecond)) {
        const error = errorFirst || errorSecond;
        return <div className="error">Fehler beim Laden der Tabelle: {error.message}</div>;
    }
    return (
        <div className="table-page">
            <div className="header-banner">
                <h1>TABELLE <br/> SAISON {config.seasonLabel}</h1>
            </div>
            <div className="table-page__table-section">
                {leagueLevel === "1" ?
                    <BigTable data={tableFirstLeague.query} title={"TABELLE 1. BUNDESLIGA"} isLoading={isLoadingTableFirst}/>
                    :
                    <>
                        <BigTable data={tableSecondLeague.NO} title={"TABELLE NORD/OST"} isLoading={isLoadingTablesSecond}/>
                        <BigTable data={tableSecondLeague.SW} title={"TABELLE SÜD/WEST"} isLoading={isLoadingTablesSecond}/>
                    </>
                }
            </div>
            <div className="table-page__legende-section">
                <TebleLegende />
            </div>
        </div>
    );
}

export default TablePage;
